<template>
  <AppointmentScreenWrapper data-qa="appointment_success">
    <template #main>
      <v-img
        contain
        :width="isClubAvailable ? 72 : 130"
        :height="isClubAvailable ? 72 : 130"
        class="mx-auto"
        :src="urls.iconSuccess"
        :alt="successData.title"
      />
      <div
        class="text--text mt-4 text-center"
        :class="{
          'text-h5': isClubAvailable,
          'text-h6': !isClubAvailable,
        }"
        data-qa="appointment_success_title"
      >
        {{ $t(successData.title, options) }}
      </div>
      <div
        v-if="successData.subtitle"
        class="text-center mt-2 mx-auto"
        :class="{
          'text-body-1 text--text': isClubAvailable,
          'text-body-2 text-secondary--text': !isClubAvailable,
        }"
        :style="{ width: '80%' }"
        data-qa="appointment_success_subtitle"
      >
        {{ $t(successData.subtitle, options) }}
      </div>
      <component
        :is="isMobile ? 'a' : 'div'"
        v-if="successData.showPhone"
        class="text-body-1 primary--text text-center"
        :href="isMobile ? `tel:${formattedLpuPhone}` : null"
        :class="{
          'd-block text-decoration-none': isMobile,
        }"
      >
        {{ lpuData.phone }}
      </component>
    </template>
    <template #actions="{ buttonProps }">
      <template v-if="isWithMedtochkaAppLink">
        <v-btn
          v-bind="buttonProps"
          data-qa="appointment_success_redirect_btn"
          color="bg-primary"
          class="my-3"
          :href="successData.medtochkaUrl"
          @click.stop="handleClickDetailButton"
        >
          <span class="primary--text">
            {{ $t('Детали записи', options) }}
          </span>
        </v-btn>
        <MedtochkaRedirect
          v-if="successData.isEnableMedtochkaRedirect"
          :redirect-url="successData.medtochkaUrl"
          data-qa="appointment_success_redirect_timer"
        />
      </template>
      <template v-else>
        <v-btn
          v-if="currentActions.buttonFirst"
          v-bind="buttonProps"
          data-qa="appointment_success_first_button"
          v-on="currentActions.buttonFirst.on"
        >
          {{ $t(currentActions.buttonFirst.text, options) }}
        </v-btn>
        <v-btn
          v-if="currentActions.buttonSecond"
          v-bind="buttonProps"
          :class="{ 'mt-3': currentActions.buttonFirst }"
          data-qa="appointment_success_second_button"
          text
          v-on="currentActions.buttonSecond.on"
        >
          {{ $t(currentActions.buttonSecond.text, options) }}
        </v-btn>
      </template>
    </template>
  </AppointmentScreenWrapper>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { sendGoogleGoal } from 'www/utils'
import { emitOpenCardInfo } from 'www/global.js.blocks/common/club-card-info/functions'
import MedtochkaRedirect from 'www/vue_components/common/MedtochkaRedirect/MedtochkaRedirect.vue'
import { APPOINTMENT_YANDEX_GOALS } from 'www/yandexGoals'
import AppointmentScreenWrapper from 'www/vue_components/common/AppointmentPage/components/common/AppointmentScreenWrapper.vue'
import {
  useLpuDataStore,
  useClubDataStore,
  useUserDataStore,
  useGlobalDataStore,
  useDoctorDataStore,
  useServiceDataStore,
  useYandexGoalsStore,
  useAuthorizationStore, // todo(useAuthMt) - удалить
  useAppointmentDataStore,
  usePreliminaryConsultationStore,
} from 'www/vue_components/common/AppointmentPage/stores'

export default {
  name: 'AppointmentSuccess',
  components: {
    MedtochkaRedirect,
    AppointmentScreenWrapper,
  },
  data: vm => ({
    isMobile: window.MOBILE_VERSION,
    storeActions: {
      understandAndAppointmentMore: {
        buttonFirst: {
          on: { click: vm.handleBack },
          text: 'Понятно',
        },
        buttonSecond: {
          on: { click: vm.handleAppointmentMore },
          text: 'Записаться ещё',
        },
      },
      good: {
        buttonFirst: {
          on: { click: vm.handleBack },
          text: 'Хорошо',
        },
      },
      goodAndOpenClubCard: {
        buttonFirst: {
          on: { click: vm.handleBack },
          text: 'Хорошо',
        },
        buttonSecond: {
          on: { click: vm.handleClickGetClubCard },
          text: 'Открыть клубную карту',
        },
      },
    },
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    ...mapState(useGlobalDataStore, [
      'urls',
      'successData',
    ]),
    ...mapState(useUserDataStore, { // todo(useAuthMt) - изменить на массив и переименовать поле
      userPhoneV2: 'userPhone',
    }),
    ...mapState(useAuthorizationStore, [ // todo(useAuthMt) - удалить
      'userPhone', // todo(useAuthMt) - удалить
    ]),
    ...mapState(useClubDataStore, [
      'userClubData',
    ]),
    ...mapState(useClubDataStore, [
      'isClubAvailable',
    ]),
    ...mapState(useAppointmentDataStore, [
      'appointmentObjectTypes',
      'useAuthMt',
    ]),
    ...mapState(useLpuDataStore, [
      'lpuData',
    ]),
    ...mapState(useLpuDataStore, [
      'formattedLpuPhone',
    ]),
    ...mapState(useDoctorDataStore, [
      'selectedDoctor',
    ]),
    ...mapState(useServiceDataStore, [
      'selectedEquipment',
    ]),
    ...mapState(usePreliminaryConsultationStore, [
      'selectedConsultingDoctor',
    ]),
    currentActions() {
      const buttonStateName = this.successData.buttonState?.[this.successData.isDialogRender ? 'post' : 'get']
      const actions = this.storeActions[buttonStateName]
      const actionsDefault = this.isMobile && this.isClubAvailable
        ? this.storeActions.goodAndOpenClubCard
        : this.storeActions.good

      return actions || actionsDefault
    },
    isWithMedtochkaAppLink() {
      return !!this.successData.medtochkaUrl
    },
  },
  mounted() {
    sendGoogleGoal('success_appointment')
    this.sendYaGoal({
      name: APPOINTMENT_YANDEX_GOALS.serviceAppointmentDirectSuccess,
      formType: 'direct',
      objectType: 'service',
    })
  },
  methods: {
    ...mapActions(useYandexGoalsStore, [
      'sendYaGoal',
    ]),
    handleBack() {
      window.history.back()
    },
    handleAppointmentMore() {
      if (this.appointmentObjectTypes.isDoctor) {
        window.location.assign(this.urls.townDoctor || document.referrer)
        return
      }

      window.location.assign(this.urls.townServices || document.referrer)
    },
    handleClickGetClubCard() {
      if (this.isMobile) {
        emitOpenCardInfo(
          this.userClubData,
          this.useAuthMt ? this.userPhoneV2 : this.userPhone,
        )

        return
      }

      window.location.assign(this.userClubData.cardMtLink)
    },
    handleClickDetailButton() {
      this.sendYaGoal({
        name: APPOINTMENT_YANDEX_GOALS.clickRedirectToMedtochka,
        formType: 'any',
        objectType: 'any',
      })
    },
  },
}
</script>
